import { Component, ViewEncapsulation, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { SbInputBase, SbInputType, sbInputProviders } from './sb-input-base.component';
import { InfoPopoverComponent } from '../../info-popover/info-popover.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ColorPickerDirective } from '../../../modules/shared/directives/colorPicker.directive';
import { SbDateTimeControlComponent } from '../sb-date-time/sb-date-time-control.component';
import { SbButtonComponent } from '../sb-button/sb-button.component';
import { FileBrowserComponent } from '../../file-browser/file-browser.component';
import { VariablesComponent } from '../../variables/variables.component';
import { SbTextConditionButtonComponent } from '../sb-text-condition/sb-text-condition-button.component';
import { FontBrowserComponent } from '../../font-browser/font-browser.component';
import { SbTextConditionHintComponent } from '../sb-text-condition/sb-text-condition-hint.component';

@Component({
  selector: 'app-sb-input-text',
  templateUrl: './sb-input-base.component.html',
  styleUrls: ['./sb-input-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: sbInputProviders(() => SbInputTextComponent),
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InfoPopoverComponent, ReactiveFormsModule, FormsModule, ColorPickerDirective, SbDateTimeControlComponent, SbButtonComponent, FileBrowserComponent, VariablesComponent, forwardRef(() => SbTextConditionButtonComponent), FontBrowserComponent, forwardRef(() => SbTextConditionHintComponent)]
})
export class SbInputTextComponent extends SbInputBase {
  /** Always a text input, whatever type is bound. */
  protected override resolveType(): SbInputType {
    return 'text';
  }
}
